<template>
    <div class="page">
        <m-header title="选择城市" subText="保存" @submitHandle="nextHandle"/>           
        <div class="page-content">
            <mt-field label="国家" disabled v-model="country">
                <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-arrow-right"></use>
                </svg>         
            </mt-field>
            <mt-field label="省份" disabled :value="takeoutProvince" @click.native="Handle('province')" v-if="mealQueryType==1">
                <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-arrow-right"></use>
                </svg>         
            </mt-field>
            <mt-field label="城市" disabled :value="takeoutCity" @click.native="Handle('city')" v-if="mealQueryType==1">
                <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-arrow-right"></use>
                </svg>         
            </mt-field>
            <mt-field label="省份" disabled :value="mealProvince" @click.native="Handle('province')" v-if="mealQueryType==2">
                <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-arrow-right"></use>
                </svg>         
            </mt-field>
            <mt-field label="城市" disabled :value="mealCity" @click.native="Handle('city')" v-if="mealQueryType==2">
                <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-arrow-right"></use>
                </svg>         
            </mt-field>                    
        </div> 
        <popup-full-picker
            v-if="results && results.length"
            :popupTypeText="popupTypeText"
            :showPicker="showPicker"
            :results="results"
            @popupHandle="popupHandle"
            @submitHandle="submitHandle"
        />                
    </div>
</template>
<script>
    import PopupFullPicker from '@/components/popup-full-picker'
    import selectInfo from '@/components/selectInfo.js' 
    import { selectCity as validator} from '@/validatorConfig/mealValidatorConfig'  
    import { mapGetters, mapMutations, mapActions } from 'vuex'  
    export default {
        extends: selectInfo,
        data() {
            return {
                results: null,
                showPicker: false, 
                mealQueryType: '' ,
                oldCity:''              
            }
        },
        created(){
                let mealQueryType = this.$route.query.mealQueryType            
                this.mealQueryType = mealQueryType
                this.iStorage.set('mealQueryType', String(this.mealQueryType))
                if(this.mealQueryType == 1) {
                    this.oldCity = this.takeoutCity
                }
                if(this.mealQueryType == 2) {
                    this.oldCity = this.mealCity
                }                
        },
        mounted() {

        },       
        methods: {
            ...mapMutations([
                'setCityDictVal',
                'setMealParams',
                'setTakeoutParams',
                'setTab'
            ]),
            nextHandle() {
                this.initProvinceCity()                  
                var input = {
                        province: this.province,
                        city: this.city
                }
                const validateResult = this.validate(input, validator);
                if(!validateResult) return; 
                if(this.mealQueryType ==1) {
                    this.setTakeoutParams({key:'TakeoutCityDictVal',value:this.city})
                    if(this.oldCity && this.oldCity!=this.city) {
                        let array = ['address','selectDate','time']
                        array.map((item)=>{
                            this.setTakeoutParams({key:item,value:""})
                        })
                    }
                }
                if(this.mealQueryType ==2) {
                    this.setMealParams({key:'MealCityDictVal',value:this.city});
                    this.setMealParams({key:'MealProvinceDictVal',value:this.province});
                    this.setMealParams({key:'MealCityGPS',value:this.gps});
                    this.setMealParams({key:'PingCityId',value:this.pingCityId});
                } 
                let backRoute = this.$route.query.backRoute
                this.$router.push({ path: backRoute }) 
                                                             
            },
            async getProvince() {
                var params = {
                    "keyCode":"CPC-Province",
                    "lnkDictVal":"中国"
                }
                const res = await this.QueryDoCityPromise(params)
            },        
        },
        components: {
            PopupFullPicker
        }
    }
</script>
<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/views/selectCity.vue